module.exports = __webpack_public_path__ + "static/media/ico_intergrate.bf06d4d5.svg";